import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Dialog,
    Box,
    Button
} from "@mui/material";
import EntitySelectionContent from "./EntitySelectionContent";

class EntitySelectionDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tempSelectionData: props.data || [],
            reloadTrigger: 0
        };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setState((prevState) => ({
                tempSelectionData: this.props.data || [],
                reloadTrigger: prevState.reloadTrigger + 1
            }));
        }
    }

    handleChange = (newSelection) => {
        this.setState({ tempSelectionData: newSelection });
    };

    handleCancel = () => {
        this.props.onClose?.();
    };

    handleSave = () => {
        this.props.onFinish?.(this.state.tempSelectionData);
    };

    render() {
        const { isOpen } = this.props;

        return (
            <Dialog
                open={!!isOpen}
                onClose={this.handleCancel}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: 3
                    }
                }}
            >
                <Box sx={{ p: 2, pt: 3, minHeight: 300 }}>
                    <EntitySelectionContent
                        {...this.props}
                        value={this.state.tempSelectionData}
                        onChange={this.handleChange}
                        reloadTrigger={this.state.reloadTrigger}
                        showCloseButton
                        onHeaderClose={this.handleCancel}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        gap: 1,
                        p: 2,
                        pt: 0
                    }}
                >
                    <Button
                        fullWidth
                        variant="outlined"
                        onClick={this.handleCancel}
                        sx={{
                            borderRadius: 2,
                            textTransform: "none"
                        }}
                    >
                        {"Abbrechen"}
                    </Button>

                    <Button
                        fullWidth
                        variant="contained"
                        onClick={this.handleSave}
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            backgroundColor: "#222",
                            "&:hover": {
                                backgroundColor: "#111"
                            }
                        }}
                    >
                        {"Speichern"}
                    </Button>
                </Box>
            </Dialog>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(EntitySelectionDialog);